'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dIndex$0024package$0024 from "./samples.-Index$package$.js";
import * as $j_scala$002eutil$002e$002dCommand$002dLine$002dParser$0024 from "./scala.util.-Command-Line-Parser$.js";
import * as $j_scala$002eutil$002e$002dCommand$002dLine$002dParser$0024$002dParse$002dError from "./scala.util.-Command-Line-Parser$-Parse-Error.js";
var $p;
function $s_Lsamples_main__main__AT__V(args) {
  try {
    $j_samples$002e$002dIndex$0024package$0024.$m_Lsamples_Index$package$().VR();
  } catch (e) {
    if (false) {
      $j_scala$002eutil$002e$002dCommand$002dLine$002dParser$0024.$m_s_util_CommandLineParser$().XD(e);
    } else {
      throw e;
    }
  }
}
export { $s_Lsamples_main__main__AT__V as $s_Lsamples_main__main__AT__V };
